import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { getTokens } from 'tamagui';

export interface SafeAreaPadding {
  topPadding: number;
  bottomPadding: number;
  leftPadding: number;
  rightPadding: number;
}

/**
 * Hook to get safe area padding values.
 * Returns an object with top, bottom, left, right padding values based on safe area insets.
 */
export const useSafeAreaPadding = (): SafeAreaPadding => {
  const insets = useSafeAreaInsets();
  const uiTokens = getTokens();
  const defaultPadding = uiTokens.space.$true.val;

  const getPadding = (inset: number): number => inset + defaultPadding;

  return {
    topPadding: getPadding(insets.top),
    bottomPadding: getPadding(insets.bottom),
    leftPadding: getPadding(insets.left),
    rightPadding: getPadding(insets.right),
  };
};
